import api from "../../services/api";

const buildPrivateFormData = (chatId, message, attachments) => {
  const fd = new FormData();
  fd.append("receiver_id", chatId);
  fd.append("message", message);
  attachments.forEach((file) => fd.append("media_files", file));
  return fd;
};

const buildRoomFormData = (chatId, message, attachments) => {
  const fd = new FormData();
  fd.append("message", message);
  attachments.forEach((file) => fd.append("media_files", file));
  return fd;
};

export const privateChatConfig = {
  queryKeyPrefix: "privateMessages",
  fetchMessages: (chatId, page) => api.getMessageHistorySpecificUser(chatId, page),
  sendMessage: (chatId, formData) => api.sendPrivateChatMessage(formData),
  buildFormData: buildPrivateFormData,
  socketEvents: ["new_message"],
  matchesChat: (payload, chat) => payload.chat_id === chat?.chat_id, // private payloads key off chat_id
};

export const roomChatConfig = {
  queryKeyPrefix: "roomMessages",
  fetchMessages: (chatId, page) => api.getLiveRoomMessages(chatId, page),
  sendMessage: (chatId, formData) => api.sendRoomChatMessage(chatId, formData),
  buildFormData: buildRoomFormData,
  socketEvents: ["new_room_message"],
  matchesChat: (payload, chat) => parseInt(payload.room_id) === chat?.chat_id, // room payloads key off room_id
};

export const getChatConfig = (chatType) => (chatType === "room" ? roomChatConfig : privateChatConfig);


